import { useTheme } from "@mui/material/styles";
export var DatePickerStyles = function () {
    var theme = useTheme();
    return {
        wrapper: function (error) { return ({
            ".MuiInputBase-input": { height: "24px" },
            ".MuiOutlinedInput-notchedOutline": {
                borderColor: error ? theme.palette.error.dark : theme.palette.grey[200],
            },
            svg: {
                color: theme.palette.success.main,
            },
        }); },
    };
};
